import { Autocomplete, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { RecordManagement } from "app/class/record-management";
import { UserOption, userLabel } from "./UserSelect";

// Multiple variant of UserSelect (value = list of sys_users ids). Shares UserSelect's query key
// so both read the same cached list; the list respects the ACL of whoever is editing.
export const UserMultiSelect = ({ value, onChange, label, placeholder, disabled = false, size }: {
    value: string[];
    onChange: (ids: string[]) => void;
    label: string;
    placeholder?: string;
    disabled?: boolean;
    size?: "small" | "medium";
}) => {
    const users = useQuery({
        queryKey: ["fluss", "metadata", "users"],
        queryFn: async () => {
            const response = await new RecordManagement<UserOption>("sys_users").orderBy("email", "asc").run();
            return response.data;
        },
        enabled: !disabled || value.length > 0,
    });
    const options = users.data || [];
    // Ids the current ACL cannot list (or deleted users) still show as chips instead of vanishing.
    const selected: UserOption[] = value.map((id) => options.find((candidate) => candidate.id === id) || { id });

    return <Autocomplete
        multiple
        fullWidth
        size={size}
        disabled={disabled}
        options={options}
        filterSelectedOptions
        getOptionLabel={userLabel}
        isOptionEqualToValue={(option, current) => option.id === current.id}
        value={selected}
        onChange={(_, next) => onChange(next.map((user) => user.id))}
        renderInput={(params) => (
            <TextField {...params} label={label} placeholder={value.length === 0 ? placeholder : undefined} />
        )}
    />;
};

export default UserMultiSelect;
